import { Pagination } from 'antd';
import { useHistorySettlementsTableStore } from 'store/historySettlementsTable';
import { useHistorySettlementsTableFiltersStore } from 'store/historySettlementsTableFilters';
import { LocalizedConfigProvider } from 'ui/LocalizedConfigProvider';
import type { TComponent } from 'utils/types/component';

export const CustomPagination: TComponent = () => {
    const params = useHistorySettlementsTableFiltersStore('params');
    const body = useHistorySettlementsTableFiltersStore('body');
    const totalElements = useHistorySettlementsTableStore('totalElements');

    const setParams = useHistorySettlementsTableFiltersStore('setParams');
    const getTable = useHistorySettlementsTableStore('getTable');

    const page = params.page + 1;

    const handleChangePage = (currentPage: number, pageSize: number) => {
        const enhancePage = currentPage - 1;

        const newParams = { ...params, page: enhancePage, size: pageSize };

        setParams(newParams);
        getTable(body, newParams);
    };

    return (
        <LocalizedConfigProvider>
            <Pagination
                showSizeChanger
                current={page}
                total={totalElements}
                onChange={handleChangePage}
            />
        </LocalizedConfigProvider>
    );
};
